import { useEffect, useRef } from 'react';

/**
 * Debounce-saves the given value via `save` after `delayMs` of inactivity.
 *
 * Used by the OnboardingProvider to persist drafts to localStorage without
 * thrashing on every keystroke. Generic so future features (e.g. dashboard
 * filters, draft replies) can reuse it.
 */
export function useDebouncedAutoSave<T>(value: T, save: (value: T) => void, delayMs = 250): void {
  const timer = useRef<number | null>(null);
  const saveRef = useRef(save);

  useEffect(() => {
    saveRef.current = save;
  }, [save]);

  useEffect(() => {
    if (timer.current) window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => saveRef.current(value), delayMs);
    return () => {
      if (timer.current) window.clearTimeout(timer.current);
    };
  }, [value, delayMs]);
}
